import { render, staticRenderFns } from "./dragVerify.vue?vue&type=template&id=0ad9eb14&scoped=true"
import script from "./dragVerify.vue?vue&type=script&lang=js"
export * from "./dragVerify.vue?vue&type=script&lang=js"
import style0 from "./dragVerify.vue?vue&type=style&index=0&id=0ad9eb14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad9eb14",
  null
  
)

export default component.exports